<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2">Popular Searchs
                        <router-link 
                            :to="{ name: 'searchs-sub', params:{root_id: this.$route.params.id} }" 
                            class="btn btn-primary btn-sm btn-pill ui-mt-10 ui-mb-2">
                            <span>Shortcut Pages</span>
                        </router-link>
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item">
                               <router-link :to="{ name: 'searchs' }">Popular Searchs</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

            <!-- Loading -->
            <div v-if="pgLoading" class="row h-100">
                <div class="container text-center">
                    <div class="spinner-grow mt-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <!-- End Loading -->

            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        


                <!-- ******* Card ******** -->
                <div class="col-md-12 mb-5">

                    <!-- Card Background -->
                    <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground">Background
                                            <span id="iconToggleBackground" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                        
                                        <div class="form-group">
                                            <label>Background 1200 * 440
                                                <button v-if="row.preview" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview = ''; row.image = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview" 
                                                :src="row.preview" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                accept="image/*"
                                                v-on:change="onImageChange">
                                        </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <!-- End Card Background -->

                    <!-- Card Mask -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMask" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Mask')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMask" 
                                        data-toggle="collapse"
                                        data-target="#collapseMask">Mask
                                        <span id="iconToggleMask" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMask" 
                                    class="collapse" 
                                    aria-labelledby="TabMask" 
                                    data-parent="#accordion">

                                <div class="col-12 row pt-3">
                        

                        <div class="col-10 tab-danger">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a href="#tab-english" 
                                                    class="nav-link active show" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="true">English
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#tab-arabic" 
                                                    class="nav-link" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="false">Arabic
                                                </a>
                                            </li>
                                        </ul>
                                        
                                        <div class="tab-content">
                                            <div role="tabpanel" 
                                                class="tab-pane fade active show" 
                                                id="tab-english">

                                                <div class="col-12 row mt-5">    

                                                    <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01"
                                            v-model="row.bgTitle"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>

                                                </div>
                                            </div>

                                            <div role="tabpanel" 
                                                class="tab-pane fade in" 
                                                id="tab-arabic">

                                                <div class="col-12 row mt-5"> 

                                                <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01_ar"
                                            v-model="row.bgTitle_ar"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group col-2 py-3 mt-10">
                                        <label for="input2">Background Color</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="color" 
                                                style="height: 200px" 
                                                v-model="row.bgColor">
                                    </div>

                                    
                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Mask -->


                    <!-- Card  -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabContent" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Content')"
                                        aria-expanded="false" 
                                        aria-controls="collapseContent" 
                                        data-toggle="collapse"
                                        data-target="#collapseContent">Page Name
                                        <span id="iconToggleContent" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseContent" 
                                    class="collapse" 
                                    aria-labelledby="TabContent" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3">
                            
                            <div class="col-12 tab-danger">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a href="#tab-english1" 
                                                    class="nav-link active show" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="true">English
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#tab-arabic1" 
                                                    class="nav-link" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="false">Arabic
                                                </a>
                                            </li>
                                        </ul>
                                        
                                        <div class="tab-content">
                                            <div role="tabpanel" 
                                                class="tab-pane fade active show" 
                                                id="tab-english1">

                                                <div class="col-12 row mt-5">

                                                     <!-- Title -->
                                    <div class="form-group col-12">
                                        <label for="input1">Title</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.title" 
                                                @keyup="onTitleChange">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group col-6">
                                        <label for="input2">Slug</label>
                                        <input class="form-control text-lowercase"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent 
                                                @paste="onSlugPaste"
                                                @change="onSlugChange(false)">
                                    </div>
                                    <!-- End Slug -->

                                    <!-- Sort -->
                                    <div class="form-group col-6">
                                        <label for="input3">Sort</label>
                                        <input class="form-control" 
                                                id="input3" 
                                                min="0"
                                                type="number" 
                                                v-model.number="row.sort">
                                    </div>
                                    <!-- End Sort -->

                                                </div>
                                            </div>

                                            <div role="tabpanel" 
                                                class="tab-pane fade in" 
                                                id="tab-arabic1">

                                                <div class="col-12 row mt-5">


                                                     <!-- Title -->
                                    <div class="form-group col-12">
                                        <label for="input1">Title</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.title_ar">
                                    </div>
                                    <!-- End Title -->


                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                   


                                    <div class="col-md-12">
                                    <h4><br/>Status & Visibility</h4>
                                    <div class="col-md-12">
                                    <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch1" 
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label" 
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Inactive' : 'Active'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <!-- Training -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch2" 
                                                    :checked="row.has_application"
                                                    @click="onApplication">
                                                <label class="custom-control-label" 
                                                    for="customSwitch2"
                                                    v-html="(row.has_application) 
                                                        ? 'Hide Application' 
                                                        : 'Show Application'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Training -->

                                        <div class="col-12 row" v-if="row.has_application">
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Application Name (en)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.application_name">
                                            </div>
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Application Name (ar)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.application_name_ar">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Application Type</label>
                                                <select class="form-control" 
                                                    v-model="row.application_path">
                                                    <option value="career-applications">
                                                        Career Application
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <!-- Faq -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch3" 
                                                    :checked="row.has_faq"
                                                    @click="onFaq">
                                                <label class="custom-control-label" 
                                                    for="customSwitch3"
                                                    v-html="(row.has_faq) ? 'Hide FAQ' : 'Show FAQ'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Faq -->

                                        <div class="col-12 row" v-if="row.has_faq">
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>FAQ Link</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.faq_link">
                                            </div>
                                        </div>

                                        <!-- Faq -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch33" 
                                                    :checked="row.has_programs"
                                                    @click="onPrograms">
                                                <label class="custom-control-label" 
                                                    for="customSwitch33"
                                                    v-html="(row.has_programs) ? 'Show Programs' : 'Hide Programs'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Faq -->



                                        <!-- Faq -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch4" 
                                                    :checked="row.has_download"
                                                    @click="onDownload">
                                                <label class="custom-control-label" 
                                                    for="customSwitch4"
                                                    v-html="(row.has_download) 
                                                    ? 'Hide Download File' : 'Show Download File'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Faq -->

                                        <div class="col-12 row" v-if="row.has_download">
                                            <div class="form-group col-3">
                                                <label>Download Title (en)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name">
                                            </div>
                                            <div class="form-group col-3">
                                                <label>Download Title (ar)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name_ar">
                                            </div>
                                            <div class="form-group col-6">
                                                <label>Download File
                                                    <button v-if="row.download_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_preview = ''; 
                                                                row.download_file = ''">
                                                        Remove File
                                                    </button>
                                                </label>
                                                <a v-if="row.download_preview" 
                                                        :href="row.download_preview" 
                                                        target="_blank" class="pull-right">Preview
                                                    </a>
                                                <input type="file" class="form-control" 
                                                @change="onFileChange">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Download Image 180 * 200
                                                    <button v-if="row.download_image_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_image_preview = ''; 
                                                                row.download_image = ''">
                                                        Remove Image
                                                    </button>
                                                </label>
                                                <p>
                                                    <img v-if="row.download_image_preview" 
                                                        :src="row.download_image_preview"
                                                        style="max-width: 50%">
                                                </p>
                                                <input type="file" class="form-control" 
                                                @change="onFilePreviewChange" accept="image/*">
                                            </div>
                                        </div>

                                    </div>
                                    </div>

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End -->



                    

                </div>
                <!-- ******* End Card ******** -->


                </div>
            </div>
            <!-- End Content -->


                <!-- Buttons -->
                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Update Popular Search</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>
                <!-- End Buttons -->


                </form>
            </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                auth: {
                    access_token: '',
                },
                row: {
                    // image
                    preview: '',
                    image: '',

                    // mask
                    bgTitle: '',
                    bgTitle_ar: '',
                    bgColor: '',

                    // pg Name
                    title: '',
                    title_ar: '',
                    slug: '',
                    sort: 0,
                    status: 1,
                    has_faq: 0,
                    faq_link: '',
                    has_programs: 0,
                    has_application: 0,
                    has_download: 0,
                    
                    download_name: '',
                    download_name_ar: '',
                    download_image_preview: '',
                    download_image: '',
                    download_preview: '',
                    download_file: '',

                    application_name: '',
                    application_name_ar: '',
                    application_path: '',
                    

                    
                },
                editor: {
                    api_key: 'xahz1dg338xnac8il0tkxph26xcaxqaewi3bd9cw9t4e6j7b',
                    menubar: 'file edit view insert format  table tc ',
                    plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount'
                            ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help',
                },

                croppieImage: '',
                cropped: false,
                pgLoading: true,
                btnLoading: false,
            }
        },
        mounted() {},
        computed: {},
        created() {

            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            this.fetchRow();

        },
        methods: {

            fetchRow(){
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/searchs/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    this.pgLoading = false;

                    this.row.status = res.data.row.status;
                    this.row.has_faq = res.data.row.has_faq;
                    this.row.faq_link = res.data.row.faq_link;
                    this.row.has_programs = res.data.row.has_programs;
                    this.row.has_application = res.data.row.has_application;
                    this.row.has_download = res.data.row.has_download;

                    this.row.download_name = res.data.row.download_name;
                    this.row.download_name_ar = res.data.row.download_name_ar;
                    this.row.download_file = res.data.row.download_file;
                    this.row.download_preview = res.data.row.download_file;
                    this.row.download_image = res.data.row.download_image;
                    this.row.download_image_preview = res.data.row.download_image;

                    this.row.application_name = res.data.row.application_name;
                    this.row.application_name_ar = res.data.row.application_name_ar;
                    this.row.application_path = res.data.row.application_path;

                    this.row.preview = res.data.row.image;
                    this.row.image = res.data.row.image;
                    this.row.sort = res.data.row.sort;
                    this.row.slug = res.data.row.slug;
                    this.row.title = res.data.row.title;
                    this.row.title_ar = res.data.row.title_ar;
                    this.row.bgTitle = res.data.row.bgTitle;
                    this.row.bgTitle_ar = res.data.row.bgTitle_ar;
                    this.row.bgColor = res.data.row.bgColor;

                    
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {});
            },
            
            // edit Row
            editRow(){
                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/searchs/'+this.$route.params.id,
                    method: 'PUT',
                    data: {
                        // image
                        image: this.row.image,

                        // mask
                        bgTitle: this.row.bgTitle,
                        bgTitle_ar: this.row.bgTitle_ar,
                        bgColor: this.row.bgColor,

                        // pgName
                        title: this.row.title,
                        title_ar: this.row.title_ar,
                        slug: this.row.slug,
                        sort: this.row.sort,
                        status: this.row.status,
                        has_faq: this.row.has_faq,
                        faq_link: this.row.faq_link,
                        has_programs: this.row.has_programs,
                        has_application: this.row.has_application,
                        has_download: this.row.has_download,

                        download_name: this.row.download_name,
                        download_name_ar: this.row.download_name_ar,
                        download_image: this.row.download_image,
                        download_file: this.row.download_file,

                        application_name: this.row.application_name,
                        application_name_ar: this.row.application_name_ar,
                        application_path: this.row.application_path,

                        
                    }
                }
                this.axios(options, config)
                    .then(() => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: 'Item Updated Successfully.',
                        });
                        this.$router.push({ name: 'searchs' })
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },


            // Title
            onTitleChange() {
                this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                }
            },

            

            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image = e.target.result;
                };
            },






            onFileChange(e){
                const file = e.target.files[0];
                this.row.download_preview = URL.createObjectURL(file);
                this.createBase64File(file);
            },
            createBase64File(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_file = e.target.result;
                };
            },

            onFilePreviewChange(e){
                const file = e.target.files[0];
                this.row.download_image_preview = URL.createObjectURL(file);
                this.createBase64FilePreview(file);
            },
            createBase64FilePreview(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_image = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            onFaq(){
                if(this.row.has_faq)
                    this.row.has_faq = 0;
                else
                    this.row.has_faq = 1;
            },
            onPrograms(){
                if(this.row.has_programs)
                    this.row.has_programs = 0;
                else
                    this.row.has_programs = 1;
            },
            onApplication(){
                if(this.row.has_application)
                    this.row.has_application = 0;
                else
                    this.row.has_application = 1;
            },
            onDownload(){
                if(this.row.has_download)
                    this.row.has_download = 0;
                else
                    this.row.has_download = 1;
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: 'searchs' });
                }
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
